import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, isRef as _isRef, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef76ec38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer-content" }
const _hoisted_2 = ["data-testid"]
const _hoisted_3 = { class: "filter-monitor" }
const _hoisted_4 = { class: "agents-table-filter-checkbox-container" }
const _hoisted_5 = ["data-testid"]
const _hoisted_6 = { class: "filter-monitor" }
const _hoisted_7 = { class: "filter-slider-container filter-slider-container--cpu" }
const _hoisted_8 = ["data-testid"]
const _hoisted_9 = { class: "filter-monitor" }
const _hoisted_10 = { class: "agents-table-filter-checkbox-container" }
const _hoisted_11 = ["data-testid"]
const _hoisted_12 = { class: "filter-monitor" }
const _hoisted_13 = ["data-testid"]
const _hoisted_14 = { class: "filter-monitor" }
const _hoisted_15 = { class: "filter-slider-container filter-slider-container--cache" }
const _hoisted_16 = ["data-testid"]
const _hoisted_17 = { class: "filter-monitor" }
const _hoisted_18 = { class: "agents-table-filter-checkbox-container" }
const _hoisted_19 = ["data-testid"]
const _hoisted_20 = { class: "filter-monitor" }
const _hoisted_21 = { class: "agents-table-filter-checkbox-container" }
const _hoisted_22 = ["data-testid"]
const _hoisted_23 = { class: "filter-monitor" }
const _hoisted_24 = { class: "agents-table-filter-checkbox-container" }
const _hoisted_25 = ["data-testid"]
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Agent Helper Permissions ")
const _hoisted_27 = { class: "filter-monitor" }
const _hoisted_28 = { class: "agents-table-filter-checkbox-container" }
const _hoisted_29 = ["data-testid"]
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Log Level ")
const _hoisted_31 = { class: "filter-monitor" }
const _hoisted_32 = { class: "agents-table-filter-checkbox-container" }
const _hoisted_33 = { class: "clear-all-btn--container full-width column items-start" }

import RangeSlider from '@/components/inputs/RangeSlider.vue';
import { computed, inject, ref, watch } from 'vue';
import { Agent_Status, useAgentsFiltersMetadataQuery, useCommonDataQuery } from '@/graphql/codegen/generated/graphql';
import { IKAgentsDrawerFilter } from '@/types/injectionKeys';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { IKAgentsSelected } from '@/views/agents/components/agents-table/agents-table.InjectionKeys';
import elementsIds from '@/const/elementIds.json';
import { BuildGroup } from '@/graphql/codegen/gql/graphql';
import { useMatomo } from '@/services/matomo/matomo.service';
import { isSystemGroup } from '@/views/agents/components/buildGroups/buildGroups.helpers';
import { SYSTEM_BUILD_GROUPS } from '@/views/agents/agents.const';
import { Constants } from '@/const/globals';
import AgentsLicenseFilter from './licenseFilter/agents-license-filter.windows.vue';
import IncrediCheckBox from '../../../../../../inputs/incrediCheckBox.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AgentTableFilters.windows',
  setup(__props) {

const matomo = useMatomo();
const coordinatorsService = inject(IKCoordinatorsService);
const agentsFilter = inject(IKAgentsDrawerFilter);
const selectedAgents = inject(IKAgentsSelected);
const getFilters = computed(() => agentsFilter?.filter.value);
const GQL_agentsFilterMetadata = useAgentsFiltersMetadataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }), {
  pollInterval: 5000,
});
const GQL_AppDataQuery = useCommonDataQuery(() => ({ coordinatorId: coordinatorsService?.selectedCoordinator.value || '' }));
const filtersOpen = ref({
  statusOpen: false,
  cpuOpen: false,
  licenseOpen: false,
  coresOpen: false,
  cacheOpen: false,
  helpersOpen: false,
  buildGroupOpen: false,
  osVersionOpen: false,
  AgentHelperPermissionsOpen: false,
  logLevelOpen: false,
});

const toggleOpenFilter = (filterName: keyof typeof filtersOpen.value, value: boolean) => {
  filtersOpen.value = { ...filtersOpen.value, [filterName]: value };
  matomo?.trackEvent({
    category: 'Agents Filter',
    action: 'Open/ Close Filter',
    name: filterName,
    value: value ? 1 : 0,
  });
};

const getAgentsLicenseTypesEnabledFilters = computed(() => ({
  withBuildCache: (GQL_agentsFilterMetadata?.result?.value?.ibManagerEntities?.agentsMetadata?.initiatorsCount || 0) > 0,
}));

const getAgentsLicenseTypesVisibility = computed(() => {
  if (!GQL_agentsFilterMetadata?.result?.value?.ibManagerEntities) return null;
  return {
    cloudAgent: GQL_agentsFilterMetadata?.result?.value?.ibManagerEntities?.settingsMetadata?.isCloudActivated,
    ciInitiator: GQL_agentsFilterMetadata?.result?.value?.ibManagerEntities?.licenseMetadata?.hasCiInitiator,
    initiator: GQL_agentsFilterMetadata?.result?.value?.ibManagerEntities?.licenseMetadata?.hasInitiator,
    withBuildCache: GQL_agentsFilterMetadata?.result?.value?.ibManagerEntities?.licenseMetadata?.hasBuildCache,
    fixedFloating: GQL_agentsFilterMetadata?.result?.value?.ibManagerEntities?.licenseMetadata?.hasFixedFloating,
  };
});
const cloudStatus = computed(() => GQL_AppDataQuery?.result?.value?.ibManagerEntities?.settings?.common?.cloud?.cloudStatus);

const getBuildGroups = computed(() => (GQL_agentsFilterMetadata?.result.value?.ibManagerEntities?.buildGroups || []).filter(buildGroup => buildGroup) as BuildGroup[]);
const sortBuildGroupsByAlphabetic = computed(
  () =>
    [...getBuildGroups.value]
      .sort((bgA, bgB) => {
        if (isSystemGroup(bgA?.id) && isSystemGroup(bgB?.id)) {
          return bgA?.id === SYSTEM_BUILD_GROUPS.Universal ? -1 : 1;
        }
        if (isSystemGroup(bgA?.id)) {
          return -1;
        }
        if (isSystemGroup(bgB?.id)) {
          return 1;
        }
        return (bgA?.name as string).localeCompare(bgB?.name as string, 'en', { sensitivity: 'base' });
      })
      .map(bg => bg?.name) as string[],
);

const getStatusFilter = computed(() => getFilters.value.status);
const getOsVersionFilter = computed(() => getFilters.value.osVersionFilter);
const isSCL = computed(() => GQL_AppDataQuery?.result?.value?.ibManagerEntities?.license?.windows?.features?.productFeatures?.includes(Constants.LICENSE_FEATURES.SCL));

watch(
  () => GQL_agentsFilterMetadata?.result?.value?.ibManagerEntities?.settingsMetadata?.isCloudActivated,
  newValue => {
    if (newValue === undefined) return;
    if (!newValue && getFilters.value.status[Agent_Status.Stopped.toLowerCase()]) {
      delete getFilters.value.status[Agent_Status.Stopped.toLowerCase()];
    } else if (newValue && !getFilters.value.status[Agent_Status.Stopped.toLowerCase()]) {
      agentsFilter?.updateFilter({
        group: 'status',
        filter: Agent_Status.Stopped.toLowerCase(),
        value: getFilters.value.status[Agent_Status.Stopped.toLowerCase()] === undefined ? true : getFilters.value.status[Agent_Status.Stopped.toLowerCase()],
      });
    }
  },
  { immediate: true },
);

const statusFilter = computed(() => Object.keys(getFilters.value.status).filter(x => getFilters.value.status[x]));
const osVersionFilter = computed(() => Object.keys(getOsVersionFilter.value).filter(x => getOsVersionFilter.value[x]));

const setStatusFilter = (value: any) => {
  const changes = Object.keys(getStatusFilter.value).filter(x => (getStatusFilter.value[x] ? !value.includes(x) : value.includes(x)));
  changes.forEach(x => {
    const newValue = !getStatusFilter.value[x];
    matomo?.trackEvent({
      category: 'Agents Filter',
      action: 'Select/ Unselect status type',
      name: x,
      value: newValue ? 1 : 0,
    });
    agentsFilter?.updateFilter({ group: 'status', filter: x, value: newValue });
  });
  agentsFilter?.setGQL_AgentsFilter('statusFilter');
  selectedAgents?.clearSelection();
};
const setOsVersionFilter = (value: any) => {
  const changes = Object.keys(getFilters?.value.osVersionFilter).filter(x => (getFilters?.value.osVersionFilter[x] ? !value.includes(x) : value.includes(x)));
  changes.forEach(x => {
    const newValue = !getFilters?.value.osVersionFilter[x];
    matomo?.trackEvent({
      category: 'Agents Filter',
      action: 'Select/ Unselect operating system type',
      name: x,
      value: newValue ? 1 : 0,
    });
    agentsFilter?.updateFilter({ group: 'osVersionFilter', filter: x, value: newValue });
  });
  agentsFilter?.setGQL_AgentsFilter('osVersionFilter');
  selectedAgents?.clearSelection();
};
const enabledCoreFilters = computed(() => agentsFilter?.filter?.value?.coreView.enabledFilters || []);
const setEnabledCoreFilters = (value: any) => {
  agentsFilter?.setEnabledCoreFilters(value);
  agentsFilter?.setGQL_AgentsFilter('coresFilter');
  selectedAgents?.clearSelection();
  matomo?.trackEvent({
    category: 'Agents Filter',
    action: 'Select / Unselect Agent cores',
  });
};
const enabledAsHelper = computed(() => getFilters.value.helpers.enabled);

const setEnabledAsHelper = (value: any) => {
  agentsFilter?.updateFilter({ group: 'helpers', filter: 'enabled', value });
  agentsFilter?.setGQL_AgentsFilter('enabledAsHelperFilter');
  selectedAgents?.clearSelection();
  matomo?.trackEvent({
    category: 'Agents Filter',
    action: 'Select / Unselect Helper Enabled',
    value: value ? 1 : 0,
  });
};

const disabledAsHelper = computed(() => getFilters.value.helpers.disabled);

const setDisabledAsHelper = (value: any) => {
  const payload = [{ group: 'helpers', filter: 'disabled', value }];
  agentsFilter?.updateFilter(payload);
  agentsFilter?.setGQL_AgentsFilter('enabledAsHelperFilter');
  selectedAgents?.clearSelection();
};

const cpuView = computed(() => getFilters.value.cpuView);
const setCpuView = (value: any) => {
  agentsFilter?.updateFilter({ group: 'cpuView', value });
  agentsFilter?.setGQL_AgentsFilter('availableCpuFilter');
  selectedAgents?.clearSelection();
};

const cacheView = computed(() => getFilters.value.cacheView);

const setCacheView = (value: any) => {
  agentsFilter?.updateFilter({ group: 'cacheView', value });
  agentsFilter?.setGQL_AgentsFilter('cacheSizeFilter');
  selectedAgents?.clearSelection();
};

const agentHelperPermissionsNotAllowed = computed(() => getFilters.value.agentHelperPermissions.notAllowed);

const setAgentHelperPermissionsNotAllowed = (value: any) => {
  const payload = [{ group: 'agentHelperPermissions', filter: 'notAllowed', value }];
  agentsFilter?.updateFilter(payload);
  agentsFilter?.setGQL_AgentsFilter('helperPermissionsFilter');
  selectedAgents?.clearSelection();
  matomo?.trackEvent({
    category: 'Agents Filter',
    action: 'Select / Unselect Agent Helper Permissions',
    value: 0,
  });
};
const agentHelperPermissionsAllowed = computed(() => getFilters.value.agentHelperPermissions.allowed);

const setAgentHelperPermissionsAllowed = (value: any) => {
  const payload = [{ group: 'agentHelperPermissions', filter: 'allowed', value }];
  agentsFilter?.updateFilter(payload);
  agentsFilter?.setGQL_AgentsFilter('helperPermissionsFilter');
  selectedAgents?.clearSelection();
  matomo?.trackEvent({
    category: 'Agents Filter',
    action: 'Select / Unselect Agent Helper Permissions',
    value: 1,
  });
};

const helpersChips = computed(() => {
  const activeCheckboxes = enabledAsHelper.value + disabledAsHelper.value;
  return activeCheckboxes !== 2 ? `${activeCheckboxes} / 2 ` : null;
});
const availableCPU = computed(() => (cpuView.value.min || cpuView.value.max < 100 ? `${cpuView.value.min}% - ${cpuView.value.max}%` : null));
const helperCacheSize = computed(() =>
  cacheView.value.min !== cacheView.value.limits.min || cacheView.value.max !== cacheView.value.limits.max ? `${cacheView.value.min}MB - ${cacheView.value.max}MB` : null,
);
const agentHelperPermissionsChips = computed(() => {
  const activeCheckboxes = agentHelperPermissionsNotAllowed.value + agentHelperPermissionsAllowed.value;
  return activeCheckboxes !== 2 ? `${activeCheckboxes} / 2 ` : null;
});

const logLevelFilter = computed(() => agentsFilter?.filter?.value?.logLevel || []);

const setLogLevelFilter = (value: any) => {
  agentsFilter?.updateFilter({
    group: 'logLevel',
    value,
  });
  agentsFilter?.setGQL_AgentsFilter('logLevelFilter');
  selectedAgents?.clearSelection();
  matomo?.trackEvent({
    category: 'Agents Filter',
    action: 'Select / Unselect Log Level',
    value: 1,
  });
};

const logLevelChips = computed(() => {
  const activeCheckboxes = Object.keys(logLevelFilter.value).filter(key => logLevelFilter.value[key]).length;
  return activeCheckboxes !== 5 ? `${activeCheckboxes} / 5 ` : null;
});
const statusFilterChips = computed(() => {
  const statusFilters = Object.keys(getStatusFilter.value);
  const enabledStatusFilters = Object.keys(getStatusFilter.value).filter(status => getStatusFilter.value[status]);
  return enabledStatusFilters.length !== statusFilters.length ? `${enabledStatusFilters.length} / ${statusFilters.length}` : null;
});
const buildGroupChips = computed(() => {
  const buildGroupsLength = getBuildGroups.value?.filter((buildGroup: any) => getFilters.value.buildGroups[buildGroup?.name]).length;
  const allAgentsBuildGroupsLength = getBuildGroups.value?.length;
  return buildGroupsLength !== allAgentsBuildGroupsLength ? `${buildGroupsLength} / ${allAgentsBuildGroupsLength}` : null;
});
const osVersionFilterChips = computed(() => {
  const osVersionFilters = Object.keys(getOsVersionFilter.value);
  const enabledOsVersionFilters = Object.keys(getOsVersionFilter.value).filter(status => getOsVersionFilter.value[status]);
  return enabledOsVersionFilters.length !== osVersionFilters.length ? `${enabledOsVersionFilters.length} / ${osVersionFilters.length}` : null;
});
const existingCoreFilters = computed(() => agentsFilter?.filter?.value?.coreView.existingFilters.slice().sort((a: any, b: any) => a - b));

const coresChips = computed(() => (enabledCoreFilters.value.length !== existingCoreFilters.value.length ? `${enabledCoreFilters.value.length}  / ${existingCoreFilters.value.length}` : null));
const additionalOptions = computed(() => {
  const options = {
    ...((getFilters.value.licensesFilter.helper ||
      getFilters.value.licensesFilter.initiator ||
      getFilters.value.licensesFilter.ciInitiator ||
      getFilters.value.licensesFilter.bothHelperAndInitiator ||
      getFilters.value.licensesFilter.bothHelperAndCIInitiator) && {
      fixedFloating: getFilters.value.licensesFilter.helperType,
    }),
    ...((getFilters.value.licensesFilter.initiator ||
      getFilters.value.licensesFilter.bothHelperAndInitiator ||
      getFilters.value.licensesFilter.ciInitiator ||
      getFilters.value.licensesFilter.bothHelperAndCIInitiator) && {
      buildCache: getFilters.value.licensesFilter.initiatorType.withBuildCache || getFilters.value.licensesFilter.ciInitiatorType.withBuildCache,
    }),
  };
  const selectedOptions = Object.keys(options).filter(key => options[key] !== 'All').length;
  return selectedOptions || null;
});

const LicensesChips = computed(() => {
  const licenseFilters = {
    cloudAgent: {
      visible: cloudStatus.value && cloudStatus.value !== 'Disabled' && getAgentsLicenseTypesVisibility.value?.cloudAgent,
      enabled: getFilters.value.licensesFilter.cloudAgent,
    },
    local: {
      visible: true,
      enabled: getFilters.value.licensesFilter.local,
    },
    helper: {
      visible: true,
      enabled: getFilters.value.licensesFilter.helper,
    },
    initiator: {
      visible: getAgentsLicenseTypesVisibility.value?.initiator,
      enabled: getFilters.value.licensesFilter.initiator,
    },
    ciInitiator: {
      visible: getAgentsLicenseTypesVisibility.value?.ciInitiator,
      enabled: getFilters.value.licensesFilter.ciInitiator,
    },
    bothHelperAndInitiator: {
      visible: getAgentsLicenseTypesVisibility.value?.initiator,
      enabled: getFilters.value.licensesFilter.bothHelperAndInitiator,
    },
    bothHelperAndCIInitiator: {
      visible: getAgentsLicenseTypesVisibility.value?.ciInitiator,
      enabled: getFilters.value.licensesFilter.bothHelperAndCIInitiator,
    },
    fixedFloating: {
      visible: getAgentsLicenseTypesVisibility.value?.fixedFloating,
      enabled: getFilters.value.licensesFilter.initiatorType.value === 'All' || getFilters.value.licensesFilter.ciInitiatorType.value === 'All',
    },
    withBuildCache: {
      visible: getAgentsLicenseTypesVisibility.value?.withBuildCache,
      enabled: getFilters.value.licensesFilter.initiatorType.withBuildCache === 'All' || getFilters.value.licensesFilter.ciInitiatorType.withBuildCache === 'All',
    },
  };

  const actualFilters = Object.keys(licenseFilters).reduce((acc, key) => {
    if (licenseFilters[key as keyof typeof licenseFilters].visible) {
      acc[key] = licenseFilters[key as keyof typeof licenseFilters].enabled;
    }
    return acc;
  }, {} as Record<string, boolean>);

  const actualExistingFilters = Object.keys(actualFilters);
  const actualEnabledFilters = actualExistingFilters.filter(key => actualFilters[key]);

  const existingOptionsLength = actualExistingFilters.length;
  const enabledOptionsLength = actualEnabledFilters.length;

  return enabledOptionsLength !== existingOptionsLength ? `${enabledOptionsLength} / ${existingOptionsLength}` : null;
});
const allAgentsBuildGroupsCheckbox = computed(() => {
  let lastVal;
  for (let i = 0; i < getBuildGroups.value?.length; i++) {
    if (lastVal === undefined) lastVal = getFilters.value.buildGroups[getBuildGroups.value[i]?.name || ''];
    else if (lastVal !== getFilters.value.buildGroups[getBuildGroups.value[i]?.name || '']) {
      lastVal = null;
      break;
    }
  }
  if (lastVal) {
    agentsFilter?.clearGQL_AgentsFilter(['buildGroupsFilter']);
  }
  return lastVal;
});
const allStatusCheckbox = computed(() => {
  if (Object.keys(getStatusFilter.value).every(key => getStatusFilter.value[key])) {
    agentsFilter?.clearGQL_AgentsFilter(['statusFilter']);

    return true;
  }
  if (Object.keys(getStatusFilter.value).some(key => getStatusFilter.value[key])) {
    return null;
  }
  return false;
});

const allOsVersionCheckbox = computed(() => {
  if (Object.keys(getOsVersionFilter.value).every(key => getOsVersionFilter.value[key])) {
    agentsFilter?.clearGQL_AgentsFilter(['osVersionFilter']);

    return true;
  }
  if (Object.keys(getOsVersionFilter.value).some(key => getOsVersionFilter.value[key])) {
    return null;
  }
  return false;
});

const allLogLevelCheckboxes = computed(() => {
  if (Object.keys(logLevelFilter.value).every(key => logLevelFilter.value[key])) {
    agentsFilter?.clearGQL_AgentsFilter(['logLevelFilter']);

    return true;
  }
  if (Object.keys(logLevelFilter.value).some(key => logLevelFilter.value[key])) {
    return null;
  }
  return false;
});

const allCoresCheckbox = computed(() => {
  if (enabledCoreFilters.value.length === existingCoreFilters.value.length) {
    agentsFilter?.clearGQL_AgentsFilter(['coresFilter']);
    return true;
  }
  if (enabledCoreFilters.value.length !== 0) return null;
  return false;
});

const getAppliedFiltersCount = computed(
  () =>
    (!!statusFilterChips.value as any) +
    !!availableCPU.value +
    !!coresChips.value +
    (!!LicensesChips.value || !!additionalOptions.value) +
    !!helperCacheSize.value +
    !!helpersChips.value +
    !!buildGroupChips.value +
    !!agentHelperPermissionsChips.value +
    !!logLevelChips.value,
);

watch(
  () => getAppliedFiltersCount,
  newValue => {
    agentsFilter?.setAgentsLeftDrawerActiveFilters(newValue.value);
  },
  { deep: true },
);

const capitalize = (value: any) => {
  if (!value) return '';
  return value.toString().charAt(0).toUpperCase() + value.slice(1);
};
const allHelperStatuses = () => {
  if (getFilters.value.helpers.enabled && getFilters.value.helpers.disabled) {
    agentsFilter?.clearGQL_AgentsFilter(['enabledAsHelperFilter']);
  }
};
const allHelperPermissions = () => {
  if (getFilters.value.agentHelperPermissions.allowed && getFilters.value.agentHelperPermissions.notAllowed) {
    agentsFilter?.clearGQL_AgentsFilter(['helperPermissionsFilter']);
  }
};
const cpuViewChanged = (e: any) => {
  setCpuView({ min: e.min, max: e.max });
  if (e.min === 0 && e.max === 100) {
    agentsFilter?.clearGQL_AgentsFilter(['availableCpuFilter']);
  }
  matomo?.trackEvent({
    category: 'Agents Filter',
    action: 'Click on Range Selector - Available CPU',
  });
};
const cacheViewChanged = (e: any) => {
  setCacheView({ min: e.min, max: e.max, limits: cacheView.value.limits });
  if (e.min === cacheView.value.limits.min && e.max === cacheView.value.limits.max) agentsFilter?.clearGQL_AgentsFilter(['cacheSizeFilter']);
  matomo?.trackEvent({
    category: 'Agents Filter',
    action: 'Click on Range for Helper Cache Size',
  });
};
const clearFilters = () => {
  agentsFilter?.clearFilters();
  agentsFilter?.clearGQL_AgentsFilter();
  matomo?.trackEvent({
    category: 'Agents Filter',
    action: 'Clear All',
  });
};

// eslint-disable-next-line no-unused-vars
const scrollToElement = (_ref: any) => {
  /* FEATURE DISABLED AT THE MOMENT */
  // const el = $refs[ref];
  // if (el) {
  //   const scrollInfo = $refs['q-scroll-area'].getScroll();
  //   const elRect = el.getBoundingClientRect();
  //   const isElementFullyVisable = elRect.bottom - scrollInfo.verticalContainerSize < 0;
  //   if (!isElementFullyVisable) {
  //     const container = $refs['q-scroll-area'].getScrollTarget();
  //     const y = elRect.top + container.scrollTop - 98;
  //     $refs['q-scroll-area'].setScrollPosition('vertical', y, 300);
  //   }
  // }
};

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_scroll_area, {
      ref: "q-scroll-area",
      class: "full-width col-grow",
      "thumb-style": { width: '4px', background: 'rgba(127, 135, 137, 0.4)', right: '2px', opacity: '1', borderRadius: '50px' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_q_list, { class: "filter-list ibf-h5 column" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                ref: "status-container",
                class: _normalizeClass(["filter-list-item shadow-focus-on-div", { 'ibf-oneline2 open': filtersOpen.value.statusOpen }]),
                "data-testid": _unref(elementsIds).agents.filtersMenu.statusFilterExpansionItem
              }, [
                _createVNode(_component_q_expansion_item, {
                  "switch-toggle-side": "",
                  "header-class": "agents-table-filter-list-header focus-be-gone ",
                  "expand-icon": "icon-right-small",
                  "expanded-icon": "icon-down-small",
                  "expand-icon-class": "filter-expand-icon",
                  "default-opened": false,
                  onHide: _cache[2] || (_cache[2] = ($event: any) => (toggleOpenFilter('statusOpen', false))),
                  onBeforeShow: _cache[3] || (_cache[3] = ($event: any) => (toggleOpenFilter('statusOpen', true))),
                  onAfterShow: _cache[4] || (_cache[4] = ($event: any) => (scrollToElement('status-container')))
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_q_item_section, { style: {"width":"80%"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.filters.status.title')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(statusFilterChips)), 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _unref(statusFilterChips) && !filtersOpen.value.statusOpen]
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(IncrediCheckBox, {
                        value: _unref(allStatusCheckbox),
                        label: 'All',
                        onInput: _cache[0] || (_cache[0] = (val) => {
                      Object.keys(_unref(getStatusFilter)).forEach(key => (_unref(getStatusFilter)[key] = val));
                      _unref(agentsFilter)?.setGQL_AgentsFilter('statusFilter');
                      _unref(selectedAgents)?.clearSelection();
                    })
                      }, null, 8, ["value"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getStatusFilter), (item, key) => {
                        return (_openBlock(), _createBlock(IncrediCheckBox, {
                          key: key,
                          "model-value": _unref(statusFilter),
                          class: "q-ml-md",
                          val: key,
                          label: capitalize(key),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = (value)=>setStatusFilter(value))
                        }, null, 8, ["model-value", "val", "label"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ], 10, _hoisted_2),
              _createElementVNode("div", {
                ref: "cpu-container",
                class: _normalizeClass(["filter-list-item shadow-focus-on-div", { 'ibf-oneline2': filtersOpen.value.cpuOpen }]),
                "data-testid": _unref(elementsIds).agents.filtersMenu.availableCPUFilterExpansionItem
              }, [
                _createVNode(_component_q_expansion_item, {
                  "switch-toggle-side": "",
                  label: _ctx.$t('agentsTable.filters.availableCpu.title'),
                  "expand-icon": "icon-right-small",
                  "expanded-icon": "icon-down-small",
                  "expand-icon-class": "filter-expand-icon",
                  "default-opened": false,
                  "header-class": "focus-be-gone agents-table-filter-list-header",
                  onBeforeHide: _cache[5] || (_cache[5] = ($event: any) => (toggleOpenFilter('cpuOpen', false))),
                  onBeforeShow: _cache[6] || (_cache[6] = ($event: any) => (toggleOpenFilter('cpuOpen', true))),
                  onAfterShow: _cache[7] || (_cache[7] = ($event: any) => (scrollToElement('cpu-container')))
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_q_item_section, { style: {"width":"80%"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.filters.availableCpu.title')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(availableCPU)), 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, !filtersOpen.value.cpuOpen && _unref(availableCPU)]
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(RangeSlider, {
                        "label-value": "%",
                        "show-hover-label": false,
                        "min-value": 0,
                        "max-value": 100,
                        value: _unref(cpuView),
                        onHandleChange: cpuViewChanged
                      }, null, 8, ["value"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"])
              ], 10, _hoisted_5),
              _createElementVNode("div", {
                ref: "cores-container",
                class: _normalizeClass(["filter-list-item shadow-focus-on-div", { 'ibf-oneline2 open': filtersOpen.value.coresOpen }]),
                "data-testid": _unref(elementsIds).agents.filtersMenu.agentsCoresFilterExpansionItem
              }, [
                _createVNode(_component_q_expansion_item, {
                  "switch-toggle-side": "",
                  "expand-icon": "icon-right-small",
                  "expanded-icon": "icon-down-small",
                  "expand-icon-class": "filter-expand-icon",
                  "default-opened": false,
                  "header-class": "focus-be-gone agents-table-filter-list-header",
                  onBeforeHide: _cache[11] || (_cache[11] = ($event: any) => (toggleOpenFilter('coresOpen', false))),
                  onBeforeShow: _cache[12] || (_cache[12] = ($event: any) => (toggleOpenFilter('coresOpen', true))),
                  onAfterShow: _cache[13] || (_cache[13] = ($event: any) => (scrollToElement('cores-container')))
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, { class: "filter-title" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.filters.cores.title')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(coresChips)), 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _unref(coresChips) && !filtersOpen.value.coresOpen]
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(IncrediCheckBox, {
                        value: _unref(allCoresCheckbox),
                        label: 'All',
                        onInput: _cache[8] || (_cache[8] = (val) => (setEnabledCoreFilters(_unref(enabledCoreFilters).length === _unref(existingCoreFilters).length ? [] : _unref(existingCoreFilters))))
                      }, null, 8, ["value"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(existingCoreFilters), (filter, index) => {
                        return (_openBlock(), _createBlock(IncrediCheckBox, {
                          key: index,
                          value: _unref(enabledCoreFilters),
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => (_isRef(enabledCoreFilters) ? (enabledCoreFilters).value = $event : null)),
                          class: "q-ml-md",
                          label: filter,
                          val: filter,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = (value) => setEnabledCoreFilters(value))
                        }, null, 8, ["value", "label", "val"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ], 10, _hoisted_8),
              _createElementVNode("div", {
                ref: "license-container",
                class: _normalizeClass(["filter-list-item shadow-focus-on-div license-filter-content", { 'ibf-oneline2 open': filtersOpen.value.licenseOpen }]),
                "data-testid": _unref(elementsIds).agents.filtersMenu.licenseFilterExpansionItem
              }, [
                _createVNode(_component_q_expansion_item, {
                  "switch-toggle-side": "",
                  label: _ctx.$t('agentsTable.filters.license.titleWindows'),
                  "expand-icon": "icon-right-small",
                  "expanded-icon": "icon-down-small",
                  "expand-icon-class": "filter-expand-icon",
                  "default-opened": false,
                  "header-class": ['focus-be-gone', 'filters-license-container'],
                  onBeforeHide: _cache[14] || (_cache[14] = ($event: any) => (toggleOpenFilter('licenseOpen', false))),
                  onBeforeShow: _cache[15] || (_cache[15] = ($event: any) => (toggleOpenFilter('licenseOpen', true))),
                  onAfterShow: _cache[16] || (_cache[16] = ($event: any) => (scrollToElement('license-container')))
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_q_item_section, { style: {"width":"80%"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.filters.license.titleWindows')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(LicensesChips)), 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _unref(LicensesChips) && !filtersOpen.value.licenseOpen]
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      (_unref(getAgentsLicenseTypesVisibility))
                        ? (_openBlock(), _createBlock(AgentsLicenseFilter, {
                            key: 0,
                            "enabled-filters": _unref(getAgentsLicenseTypesEnabledFilters),
                            visibility: _unref(getAgentsLicenseTypesVisibility)
                          }, null, 8, ["enabled-filters", "visibility"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["label"])
              ], 10, _hoisted_11),
              _createElementVNode("div", {
                ref: "cache-container",
                class: _normalizeClass(["filter-list-item shadow-focus-on-div", { 'ibf-oneline2': filtersOpen.value.cacheOpen }]),
                "data-testid": _unref(elementsIds).agents.filtersMenu.helperCacheFilterExpansionItem
              }, [
                _createVNode(_component_q_expansion_item, {
                  "switch-toggle-side": "",
                  label: _ctx.$t('agentsTable.filters.cache.title'),
                  "expand-icon": "icon-right-small",
                  "expanded-icon": "icon-down-small",
                  "expand-icon-class": "filter-expand-icon",
                  "default-opened": false,
                  "header-class": "focus-be-gone agents-table-filter-list-header",
                  onBeforeHide: _cache[17] || (_cache[17] = ($event: any) => (toggleOpenFilter('cacheOpen', false))),
                  onBeforeShow: _cache[18] || (_cache[18] = ($event: any) => (toggleOpenFilter('cacheOpen', true))),
                  onAfterShow: _cache[19] || (_cache[19] = ($event: any) => (scrollToElement('cache-container')))
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_q_item_section, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.filters.cache.title')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(helperCacheSize)), 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, !filtersOpen.value.cacheOpen && _unref(helperCacheSize)]
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(RangeSlider, {
                        "label-value": "MB",
                        "show-hover-label": false,
                        "min-value": _unref(cacheView).limits.min,
                        "max-value": _unref(cacheView).limits.max,
                        value: _unref(cacheView),
                        onHandleChange: cacheViewChanged
                      }, null, 8, ["min-value", "max-value", "value"])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"])
              ], 10, _hoisted_13),
              _createElementVNode("div", {
                ref: "helpers-container",
                class: _normalizeClass(["filter-list-item shadow-focus-on-div", { 'ibf-oneline2 open': filtersOpen.value.helpersOpen }]),
                "data-testid": _unref(elementsIds).agents.filtersMenu.helperEnabledFilterExpansionItem
              }, [
                _createVNode(_component_q_expansion_item, {
                  "switch-toggle-side": "",
                  "expand-icon": "icon-right-small",
                  "expanded-icon": "icon-down-small",
                  "expand-icon-class": "filter-expand-icon",
                  "default-opened": false,
                  "header-class": "focus-be-gone agents-table-filter-list-header",
                  onBeforeHide: _cache[24] || (_cache[24] = ($event: any) => (toggleOpenFilter('helpersOpen', false))),
                  onBeforeShow: _cache[25] || (_cache[25] = ($event: any) => (toggleOpenFilter('helpersOpen', true))),
                  onAfterShow: _cache[26] || (_cache[26] = ($event: any) => (scrollToElement('helpers-container')))
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_q_item_section, { style: {"width":"80%"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.filters.helpers.title')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(helpersChips)), 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _unref(helpersChips) && !filtersOpen.value.helpersOpen]
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(IncrediCheckBox, {
                        "model-value": _unref(enabledAsHelper),
                        label: "Enabled as helper",
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_unref(enabledAsHelper) ? allHelperStatuses() : null)),
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = (value) => setEnabledAsHelper(value))
                      }, null, 8, ["model-value"]),
                      _createVNode(IncrediCheckBox, {
                        "model-value": _unref(disabledAsHelper),
                        label: "Disabled as helper",
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_unref(disabledAsHelper) ? allHelperStatuses() : null)),
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = (value) => setDisabledAsHelper(value))
                      }, null, 8, ["model-value"])
                    ])
                  ]),
                  _: 1
                })
              ], 10, _hoisted_16),
              _createElementVNode("div", {
                ref: "build-groups-container",
                class: _normalizeClass(["filter-list-item shadow-focus-on-div", { 'ibf-oneline2 open': filtersOpen.value.buildGroupOpen }]),
                "data-testid": _unref(elementsIds).agents.filtersMenu.buildGroupsFilterExpansionItem
              }, [
                _createVNode(_component_q_expansion_item, {
                  "data-testid": "build-groups-filter",
                  "switch-toggle-side": "",
                  "header-class": "agents-table-filter-list-header focus-be-gone",
                  "expand-icon": "icon-right-small",
                  "expanded-icon": "icon-down-small",
                  "expand-icon-class": "filter-expand-icon",
                  "default-opened": false,
                  onHide: _cache[28] || (_cache[28] = ($event: any) => (toggleOpenFilter('buildGroupOpen', false))),
                  onAfterShow: _cache[29] || (_cache[29] = ($event: any) => (scrollToElement('build-groups-container'))),
                  onBeforeShow: _cache[30] || (_cache[30] = ($event: any) => (toggleOpenFilter('buildGroupOpen', true)))
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_q_item_section, { style: {"width":"80%"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.filters.buildGroups.title')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(buildGroupChips)), 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _unref(buildGroupChips) && !filtersOpen.value.buildGroupOpen]
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(IncrediCheckBox, {
                        value: _unref(allAgentsBuildGroupsCheckbox),
                        label: 'All',
                        "data-testid": "all-build-groups-checkbox",
                        onInput: _cache[27] || (_cache[27] = (val) => {
                      _unref(getBuildGroups)?.forEach((buildGroup) => {
                        _unref(agentsFilter)?.updateFilter({ group: 'buildGroups', filter: buildGroup?.name, value: val });
                      });

                      _unref(agentsFilter)?.setGQL_AgentsFilter('buildGroupsFilter');
                      _unref(selectedAgents)?.clearSelection();
                      _unref(matomo)?.trackEvent({
                        category: 'Agents Filter',
                        action: 'Select / Unselect Build Groups',
                      });
                    })
                      }, null, 8, ["value"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortBuildGroupsByAlphabetic), (item, key) => {
                        return (_openBlock(), _createBlock(IncrediCheckBox, {
                          key: key,
                          value: !!_unref(getFilters).buildGroups[item],
                          class: "q-ml-md",
                          label: item,
                          "data-testid": `build-group-checkbox-${item}`,
                          onInput: (val) => {
                      _unref(agentsFilter)?.updateFilter({ group: 'buildGroups', filter: item, value: val });
                      _unref(agentsFilter)?.setGQL_AgentsFilter('buildGroupsFilter');
                      _unref(selectedAgents)?.clearSelection();
                    }
                        }, null, 8, ["value", "label", "data-testid", "onInput"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ], 10, _hoisted_19),
              (_unref(isSCL))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    ref: "os-version-container",
                    class: _normalizeClass(["filter-list-item shadow-focus-on-div", { 'ibf-oneline2 open': filtersOpen.value.osVersionOpen }]),
                    "data-testid": _unref(elementsIds).agents.filtersMenu.buildOsVersionFilterExpansionItem
                  }, [
                    _createVNode(_component_q_expansion_item, {
                      "switch-toggle-side": "",
                      "header-class": "agents-table-filter-list-header focus-be-gone ",
                      "expand-icon": "icon-right-small",
                      "expanded-icon": "icon-down-small",
                      "expand-icon-class": "filter-expand-icon",
                      "default-opened": false,
                      onHide: _cache[33] || (_cache[33] = ($event: any) => (toggleOpenFilter('osVersionOpen', false))),
                      onBeforeShow: _cache[34] || (_cache[34] = ($event: any) => (toggleOpenFilter('osVersionOpen', true))),
                      onAfterShow: _cache[35] || (_cache[35] = ($event: any) => (scrollToElement('os-version-container')))
                    }, {
                      header: _withCtx(() => [
                        _createVNode(_component_q_item_section, { style: {"width":"80%"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('agentsTable.filters.osVersion.title')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_q_item_section, { side: "" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(osVersionFilterChips)), 1)
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _unref(osVersionFilterChips) && !filtersOpen.value.osVersionOpen]
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(IncrediCheckBox, {
                            value: _unref(allOsVersionCheckbox),
                            label: 'All',
                            onInput: _cache[31] || (_cache[31] = (val) => {
                      Object.keys(_unref(getOsVersionFilter)).forEach(key => (_unref(getOsVersionFilter)[key] = val));
                      _unref(agentsFilter)?.setGQL_AgentsFilter('osVersionFilter');
                      _unref(selectedAgents)?.clearSelection();
                    })
                          }, null, 8, ["value"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getOsVersionFilter), (item, key) => {
                            return (_openBlock(), _createBlock(IncrediCheckBox, {
                              key: key,
                              "model-value": _unref(osVersionFilter),
                              class: "q-ml-md",
                              val: key,
                              label: capitalize(key),
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = (value)=>setOsVersionFilter(value))
                            }, null, 8, ["model-value", "val", "label"]))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ], 10, _hoisted_22))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                ref: "agent-helper-permissions-container",
                class: _normalizeClass(["filter-list-item shadow-focus-on-div", { 'ibf-oneline2 open': filtersOpen.value.AgentHelperPermissionsOpen }]),
                "data-testid": _unref(elementsIds).agents.filtersMenu.helperPermissionFilterExpansionItem
              }, [
                _createVNode(_component_q_expansion_item, {
                  "switch-toggle-side": "",
                  "header-class": "agents-table-filter-list-header focus-be-gone",
                  "expand-icon": "icon-right-small",
                  "expanded-icon": "icon-down-small",
                  "expand-icon-class": "filter-expand-icon",
                  "default-opened": false,
                  onHide: _cache[42] || (_cache[42] = ($event: any) => (toggleOpenFilter('AgentHelperPermissionsOpen', false))),
                  onBeforeShow: _cache[43] || (_cache[43] = ($event: any) => (toggleOpenFilter('AgentHelperPermissionsOpen', true))),
                  onAfterShow: _cache[44] || (_cache[44] = ($event: any) => (scrollToElement('agent-helper-permissions-container')))
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_q_item_section, { style: {"width":"80%"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _hoisted_26
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(agentHelperPermissionsChips)), 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _unref(agentHelperPermissionsChips) && !filtersOpen.value.AgentHelperPermissionsOpen]
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(IncrediCheckBox, {
                        value: _unref(agentHelperPermissionsAllowed),
                        "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => (_isRef(agentHelperPermissionsAllowed) ? (agentHelperPermissionsAllowed).value = $event : null)),
                        label: "Allowed to 'Enable/Disable' as Helper",
                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_unref(agentHelperPermissionsAllowed) ? allHelperPermissions() : null)),
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = (value) => setAgentHelperPermissionsAllowed(value))
                      }, null, 8, ["value"]),
                      _createVNode(IncrediCheckBox, {
                        value: _unref(agentHelperPermissionsNotAllowed),
                        "onUpdate:value": _cache[39] || (_cache[39] = ($event: any) => (_isRef(agentHelperPermissionsNotAllowed) ? (agentHelperPermissionsNotAllowed).value = $event : null)),
                        label: "Not allowed to 'Enable/Disable'",
                        onClick: _cache[40] || (_cache[40] = ($event: any) => (_unref(agentHelperPermissionsNotAllowed) ? allHelperPermissions() : null)),
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = (value)=> setAgentHelperPermissionsNotAllowed(value))
                      }, null, 8, ["value"])
                    ])
                  ]),
                  _: 1
                })
              ], 10, _hoisted_25),
              _createElementVNode("div", {
                ref: "log-level-container",
                class: _normalizeClass(["filter-list-item shadow-focus-on-div", { 'ibf-oneline2 open': filtersOpen.value.logLevelOpen }]),
                "data-testid": _unref(elementsIds).agents.filtersMenu.logLevelFilterExpansionItem
              }, [
                _createVNode(_component_q_expansion_item, {
                  "switch-toggle-side": "",
                  "header-class": "agents-table-filter-list-header focus-be-gone",
                  "expand-icon": "icon-right-small",
                  "expanded-icon": "icon-down-small",
                  "expand-icon-class": "filter-expand-icon",
                  "default-opened": false,
                  onHide: _cache[46] || (_cache[46] = ($event: any) => (toggleOpenFilter('logLevelOpen', false))),
                  onBeforeShow: _cache[47] || (_cache[47] = ($event: any) => (toggleOpenFilter('logLevelOpen', true))),
                  onAfterShow: _cache[48] || (_cache[48] = () => scrollToElement('log-level-container'))
                }, {
                  header: _withCtx(() => [
                    _createVNode(_component_q_item_section, { style: {"width":"80%"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_label, null, {
                          default: _withCtx(() => [
                            _hoisted_30
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_q_item_section, { side: "" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(logLevelChips)), 1)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _unref(logLevelChips) && !filtersOpen.value.logLevelOpen]
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(IncrediCheckBox, {
                        label: "All",
                        value: _unref(allLogLevelCheckboxes),
                        onInput: _cache[45] || (_cache[45] = (val) => 
                  setLogLevelFilter(Object.keys(_unref(logLevelFilter)).reduce((acc,key) => ({...acc,[key]: val}),{}))
                  )
                      }, null, 8, ["value"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(logLevelFilter)), (key, index) => {
                        return (_openBlock(), _createBlock(IncrediCheckBox, {
                          key: index,
                          label: `${index + 1} - ${key}`,
                          value: _unref(logLevelFilter)[key],
                          class: "q-ml-md",
                          onInput: (newVal) => setLogLevelFilter({ ..._unref(logLevelFilter), [key]: newVal })
                        }, null, 8, ["label", "value", "onInput"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ], 10, _hoisted_29)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["thumb-style"]),
    _createElementVNode("div", _hoisted_33, [
      _createVNode(_component_q_btn, {
        style: {"padding":"4px 16px"},
        label: "Clear All",
        class: "ibf-button1 incredi-button-ibx primary-light",
        "no-caps": "",
        unelevated: "",
        "data-testid": _unref(elementsIds).agents.filtersMenu.clearAllFiltersButton,
        onClick: clearFilters
      }, null, 8, ["data-testid"])
    ])
  ]))
}
}

})